import axios from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  appointment: '/appointments',
  doctor: '/doctors',
  drug: '/drugs',
  invoice: '/invoices',
  record: '/records',
  recordFile: '/files',
  guardian: '/guardians',
  order: '/orders',
  patient: '/patients',
  service: '/services',
  subscription: '/subscriptions',
  plan: '/plans',
  product: '/products',
  price: '/prices',
  customer: '/customers',
  kanban: '/boards',
  admin: {
    customer: '/customers',
    team: {
      create: '/teams',
      removeMember: 'teams/member',
    },
    users: '/users',
  },
  member: '/members',
  billing: {
    checkout: '/billing/checkout',
    invoice: '/billing/invoices',
  },
  team: {
    create: '/teams',
    getMyTeams: '/teams',
    getMembers: '/teams/members',
    update: '/teams/update',
    delete: '/teams/delete',
    invite: '/teams/invite',
    revoke: '/teams',
    updateInvitation: '/teams',
    removeMember: '/teams',
    updateMember: '/teams/members/update',
  },
  auth: {
    me: '/auth/session',
    login: '/auth/login',
    magicCode: '/auth/login/code',
    requestMagicCode: '/auth/send/login/code',
    github: '/auth/login/github',
    register: '/users',
    google: '/auth/login/google',
    twitter: '/auth/login/twitter',
    logout: '/auth/logout',
    verifyEmail: '/auth/verify/email',
    resendVerificationCode: '/auth/resend/verification/email',
    forgetPassword: '/auth/reset/password',
    forgetPasswordOtp: '/auth/reset/password/code/verify',
    updatePassword: '/auth/reset/password/verify',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  email: {
    support: '/emails/support',
    marketing: '/emails/marketing',
    invoice: '/emails/invoice',
    prescription: '/emails/prescription',
  },
  // product: {
  //   list: '/api/product/list',
  //   details: '/api/product/details',
  //   search: '/api/product/search',
  // },
};
